import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow--cta",
  "use": "icon-arrow--cta-usage",
  "viewBox": "0 0 8 12",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 8 12\" id=\"icon-arrow--cta\"><path d=\"m1 1 5 5-5 5\" stroke=\"#fff\" stroke-width=\"2\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol